import React from "react";
import Button from "react-bootstrap/Button";

import { Wrapper } from "./styledSecondaryButton";

const SecondaryButtonComponent = ({
  titleButton,
  handleClickButton,
  isDisabledButton,
  wrapperButtonclassName,
  buttonType,
  buttonHeight,
  fontSize,
}) => {
  return (
    <Wrapper
      className={wrapperButtonclassName}
      $height={buttonHeight}
      $fontSize={fontSize}
    >
      <Button
        name="add"
        type={buttonType}
        onClick={handleClickButton}
        className={isDisabledButton ? "disactive-button" : "active-button"}
        disabled={isDisabledButton}
      >
        {titleButton}
      </Button>
    </Wrapper>
  );
};

export default SecondaryButtonComponent;
